import { forwardRef } from "react";
import { useMergedRefs } from "../../common/hooks";
import { A11yBase } from "../a11y-base";
import { useKeyboardA11y } from "../hooks";
import { A11yProps } from "./types";

export const A11y = forwardRef<HTMLElement, A11yProps>((props, ref) => {
  const { currentRef, mergedRefs } = useMergedRefs(ref);

  const { handleKeyDown } = useKeyboardA11y({
    Enter: () => currentRef.current?.click(),
  });

  return <A11yBase {...props} onKeyDown={handleKeyDown} ref={mergedRefs} />;
});

A11y.displayName = "A11y";
